module.exports = {
      id: "audio-forward-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#audio-forward",
      toString: function () {
        return this.url;
      }
    }